import * as React from "react";
import { styled, SxProps } from "@mui/material";
import "swiper/css";

import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export type SliderControlProps = {
  sx?: SxProps;
  controlType: "prev" | "next";
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const SliderControl: React.FC<SliderControlProps> = (props) => {
  const { controlType, ...otherProps } = props;

  return (
    <SwiperControl {...otherProps} controlType={controlType}>
      {controlType === "prev" ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
    </SwiperControl>
  );
};

export default SliderControl;

const SwiperControl = styled("button", { shouldForwardProp: (prop) => prop !== "sx" && prop !== "controlType" })<{
  controlType: SliderControlProps["controlType"];
}>(({ theme, controlType }) => ({
  position: "absolute",
  left: theme.spacing(-3),
  top: "50%",
  transform: "translateY(-50%)",
  zIndex: 2,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",

  border: "none",
  width: 40,
  height: 40,
  boxShadow: theme.palette.mode === "dark" ? "0px 4px 16px rgba(0, 0, 0, 0.52)" : "0px 4px 16px rgba(0, 0, 0, 0.2)",
  borderRadius: 8,
  backgroundColor: theme.palette.background[400],
  cursor: "pointer",

  color: "white",
  transition: "opacity .3s, background .3s",

  ...(controlType === "next" && {
    left: "auto",
    right: 0,
  }),
  "&[disabled]": {
    opacity: 0,
    pointerEvents: "none",
  },
  "&:hover": {
    backgroundColor: "#454569",
  },
}));
